<div
  class="date-picker-overlay"
  *ngIf="show && showCustomDatePicker"
  (click)="$event.stopPropagation()"
>
  <div class="date-picker-container">
    <!-- Header -->
    <div class="date-picker-header">
      <h4>{{ displayTitle }}</h4>
      <button class="btn-close-picker" (click)="cancelCustomDateRange()" type="button">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Calendar -->
    <p-calendar
      [(ngModel)]="customDateRange"
      [selectionMode]="selectionMode"
      [showButtonBar]="showButtonBar"
      [monthNavigator]="true"
      [yearNavigator]="true"
      [yearRange]="yearRange"
      [maxDate]="allowFutureDates ? maxDate : (maxDate || today)"
      [minDate]="minDate"
      (onSelect)="onCustomDateSelect()"
      [placeholder]="displayTitle"
      styleClass="compact-calendar"
      [inline]="true"
    ></p-calendar>

    <!-- Actions -->
    <div class="date-range-actions">
      <button class="btn-apply-date" (click)="applyCustomDateRange()" type="button">Apply</button>
      <button class="btn-cancel-date" (click)="cancelCustomDateRange()" type="button">Cancel</button>
    </div>
  </div>
</div>
